<template>
  <div class="classDiv">
    <div style="padding-bottom: 60px">
      <header>
        <div class="headerDiv" v-on:click="backHistory"  @click="">
          <img src="@/assets/img/back.png" alt="">
          <p style="color: #FFFFFF">分类</p>
        </div>
      </header>
    </div>
    <!--<van-sidebar style="height: 100%" v-model="activeKey">-->
      <!--<van-sidebar-item title="标签名称" />-->
      <!--<van-sidebar-item title="标签名称" />-->
      <!--<van-sidebar-item title="标签名称" />-->
    <!--</van-sidebar>-->
    <div style="height: 90%;">
      <van-tree-select height="100%" :items="items" :main-active-index.sync="active" @click-nav="onChange">
        <template #content>
          <div>
          <!--<van-image src="https://img01.yzcdn.cn/vant/apple-1.jpg"/>-->
          <div v-if="item.item" v-for="(item,index) in list" >
            <h3 v-if="item.item.length!=0">{{item.title}}</h3>
            <!--<h3 v-if="item.item">{{item}}</h3>-->
           <div class="activeDiv" v-for="(pros,index) in item.item" @click="toClass(pros)">
             <div class="activeImgDiv">
               <img :src="pros.image" alt="">
             </div>
             <span>{{pros.title}}</span>
           </div>
          </div>
          </div>
          <!--<van-image-->
            <!--v-if="active === 1"-->
            <!--src="https://img01.yzcdn.cn/vant/apple-2.jpg"-->
          <!--/>-->
        </template>
      </van-tree-select>
    </div>
    <div class="go">
      <img style="width: 60px"  @click="href()" src="@/assets/img/go2.png" alt="">
    </div>
    <van-tabbar route  active-color="#ff2500">
      <van-tabbar-item replace to="/home" icon="wap-home-o">
        商城
      </van-tabbar-item>
      <van-tabbar-item replace to="/homeClass" icon="wap-home-o">
        分类
      </van-tabbar-item>
      <van-tabbar-item replace to="/newShop" icon="wap-home-o">
        购物车
      </van-tabbar-item>

      <van-tabbar-item replace to="/myShop" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        all:false,
        activeKey:1,
        active: 0,
        items: [
//          { text: '分组 1',id:0 }, { text: '分组 2',id:2 }
        ],
        list:[],
        codeId:""
      }
    },
    methods: {
      backHistory(){
        this.$router.push("/")
      },
      toClass(item){
        console.log(item)
        this.$router.push({
          path:"/classification",
          query:{
            id:item.id,
            text:item.title
          }
        })
      },

      // 选中单个商品

      homeClass(){//分类
        this.$api.shopclassification({
//          id:1
        })
          .then(res=>{
            res.data.forEach(item=>{
              this.items.push({text:item.title,id:item.id})
            });
            this.onChange(0)
          })
      },
      onChange(index){
        let substationCode = this.items[index].id
        this.$api.shopclassification({
          id:substationCode
        })
          .then(res=>{
            this.list=res.data

          })
      }
    },
    mounted(){
     this.homeClass()
      console.log(this.codeId)
//     this.homeClassRight()
    },

  }
</script>
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  .go{
    position: fixed;
    top: 70%;
    right: 10px;
  }
  .classDiv{
    width: 100%;
    height: 100%;
  }
  header{
    width: 100%;
    height: 50px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 18px;
    height: 18px;
    padding-left: 10px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 50px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 15px;
  }
/deep/.van-sidebar-item{
  text-align: center;
  padding: 15px 0;
}

  .activeImgDiv img{
    width: 50px;
    border-radius: 1rem;
  }
  .activeDiv{
    width: 25%;
    display: inline-block;
    text-align: center;
    padding: 10px;
  }
  .activeDiv span{
    display: inline-block;
    padding-top: 8px;
    white-space: nowrap;
    font-size: 12px;
  }
  h3{
    padding: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/homeClass.vue